module.exports = __webpack_public_path__ + "img/whitePlus.d814c20d.svg";